import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class NewsWidgetDisplayEvent extends BaseAnalyticsEvent {
  countryId: Number;
  langId: Number;
  sportTypeId: Number;

  constructor(params) {
    super('', 'display', 'articles-component');

    this.countryId = params.countryId;
    this.langId = params.langId;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.countryId = this.countryId;
    properties.langId = this.langId;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}